module.exports = __webpack_public_path__ + "img/huaxue.173cffdc.png";